import React, { useEffect, useState } from "react";
import { Table, Button, Form, InputGroup, Pagination, ToastContainer } from "react-bootstrap";
import { PencilSquare, Trash, Check, X, Check2Circle, XCircle } from "react-bootstrap-icons";
import NewTopNavBar from "../NewTopNavBar";
import { toast } from "react-toastify";
import axios from "axios";
import { API_BASE_URL } from "../../environment";
import { useNavigate } from "react-router-dom";
import addImg from "../../Img/add.png";
import swichImg from "../../Img/settings.png"
const moduleOptions = [
{'value':'tickets','lable':'Ticketing'},
{'value':'aichat','lable':'AI Search'},
{'value':'home','lable':'Basic Search'},
];

// {'value':'tickets','lable':'Ticket Tab'},
// {'value':'aichat','lable':'AIchat'},

// const vendorOptions = ['jira', 'zoho', 'ServiceNow'];
const vendorOptions = [{'lable':'Jira','value':'jira'}, {'lable':'Zoho', 'value':'zoho'}, {'lable':'ServiceNow','value':'ServiceNow'}];
const TenantConfigTable = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [newRow, setNewRow] = useState(null);
  const [editingId, setEditingId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const navigate=useNavigate()
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  useEffect(() => {
    fetchData();
  }, [data.length]);

  const fetchData = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/wp-json/custom/v1/tenant-conf-modules`,config);
      setData(res.data);
    } catch {
      toast.error('Failed to fetch data');
    }
  };

  const handleAddRow = () => {
    setNewRow({
      whitelist_url: '',
      tenant_url: '',
      module_section: [],
      vendor_ticketing_system: '',
      view_sdk_client: '',
    });
  };

  const handleChange = (field, value, id = null) => {
    if (id !== null) {
      setData((prev) =>
        prev.map((row) =>
          row.id === id ? { ...row, [field]: value } : row
        )
      );
    } else {
      setNewRow({ ...newRow, [field]: value });
    }
  };

  const handleSaveNew = async () => {
    if(!newRow.whitelist_url || !newRow.tenant_url || newRow.module_section.length==0 || !newRow.vendor_ticketing_system || !newRow.view_sdk_client){
      toast.error('All fields are required');
      return;
    }
    try {
      const res = await axios.post(`${API_BASE_URL}/wp-json/custom/v1/tenant-conf-modules`, newRow,config);
      setData([res.data, ...data]);
      setNewRow(null);
      toast.success('Ticketing Details created successfully');
    } catch {
      toast.error('Failed to create details - The provided Whitelist URL and Tenant URL already exist. Please enter different values.');
    }
  };

  const handleEdit = (id) => setEditingId(id);

  const handleSaveEdit = async (id) => {
    const row = data.find((r) => r.id === id);
    if(!row.whitelist_url || !row.tenant_url || row.module_section.length==0 || !row.vendor_ticketing_system || !row.view_sdk_client){
      toast.error('All fields are required');
      return;
    }
    console.log('test87=',row)
    try {
      await axios.put(`${API_BASE_URL}/wp-json/custom/v1/tenant-conf-modules/${id}`,row,config);
      toast.success('Ticketing Details updated successfully');
      setEditingId(null);
    } catch {
      toast.error('Failed to update Ticketing Details');
    }
  };

  const handleDelete = (id) => {
    axios.delete(`${API_BASE_URL}/wp-json/custom/v1/tenant-conf-modules/${id}`,config).then((res)=>{
      toast.success('row deleted successfully')
    }).catch((err)=>{
      console.log(err)
      toast.error('row is not deleted successfully')
    })
  };

  const filteredData = data.filter((row) =>
    Object.values(row).some((value) =>
      JSON.stringify(value).toLowerCase().includes(search.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = filteredData.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const formatModuleNames = (values) => {
    if (!values || !Array.isArray(values)) return '';
    return values
      .map((val) => {
        const found = moduleOptions.find((opt) => opt.value === val);
        return found ? found.lable : val;
      })
      .join(', ');
  };
  return (
    <div className="">
      <NewTopNavBar/>
      <div className="container mt-4 pt-5">
      <h4 className="text-center">Manage Solviya Configuration</h4>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="d-flex justify-content-end mb-3">
      <InputGroup style={{ width: '300px' }} className="d-none">
          <Form.Control
            placeholder="Search..."
            onChange={(e) => setSearch(e.target.value)}
          />
        </InputGroup>
        {/* <div>
        <Button onClick={()=>navigate('/tenant-configaration')}>Admin Config</Button>
        <Button className="d-none" onClick={handleAddRow}>Add</Button>
        </div> */}

                <div>
                  {/* <button className='btn btn-primary' onClick={handleShowCategory}>  {editWhistlist ? "Add/Edit" : "Add"} categories</button> */}
                  <img
                    className="mt-2 commonLogo"
                    onClick={()=>navigate('/tenant-configaration')}
                    width={25}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title="Admin Configuration "
                    role="button"
                    src={swichImg}
                    alt="Admin Configuration "
                  />
                </div>

      </div>

      <Table striped bordered responsive>
        <thead>
          <tr className="text-center">
            <th>Whitelist URL</th>
            <th>KR Main URL</th>
            <th>Module Selection</th>
            <th>Ticketing Platform</th>
            <th>View SDK ID</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {newRow && (
            <tr className="tenat-config-table">
              <td>
                <Form.Control
                  value={newRow.whitelist_url}
                  onChange={(e) =>
                    handleChange('whitelist_url', e.target.value)
                  }
                />
              </td>
              <td>
                <Form.Control
                  value={newRow.tenant_url}
                  onChange={(e) =>
                    handleChange('tenant_url', e.target.value)
                  }
                />
              </td>
              <td>
                {/* <Form.Select
                  multiple
                  value={newRow.module_section}
                  onChange={(e) =>
                    handleChange(
                      'module_section',
                      Array.from(e.target.selectedOptions, (o) => o.value)
                    )
                  }
                >
                 
                  {moduleOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                  {opt.label}
                  </option>
                  ))}
                </Form.Select> */}
                  {/* Checkboxes */}
                {moduleOptions.map((opt) => (
                  <>
              <Form.Check
                key={opt.value}
                type="checkbox"
                label={opt.lable}
                checked={newRow.module_section?.includes(opt.value)}
                onChange={(e) => {
                  const updated = e.target.checked

                    ? [...(newRow.module_section || []), opt.value]
                    : (newRow.module_section || []).filter((val) => val !== opt.value);
                    
                  handleChange('module_section', updated);
               }}
              />
              <label htmlFor="">{opt.lable}</label>
              </>
                ))}
              </td>
              <td>
                <Form.Select
                  value={newRow.vendor_ticketing_system}
                  onChange={(e) =>
                    handleChange('vendor_ticketing_system', e.target.value)
                  }
                >
                  <option value="">Select</option>
                  {vendorOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.lable}
                    </option>
                  ))}
                </Form.Select>
              </td>
              <td>
                <Form.Control
                  value={newRow.view_sdk_client}
                  onChange={(e) =>
                    handleChange('view_sdk_client', e.target.value)
                  }
                />
              </td>
              <td>
                <Check2Circle
                  color="green"
                  size={22}
                  style={{ cursor: 'pointer', marginRight: '10px' }}
                  onClick={handleSaveNew}
                />
                <XCircle
                  color="red"
                  size={22}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setNewRow(null)}
                />
              </td>
            </tr>
          )}

          {currentData.map((row) => (
            <tr className="tenat-config-table text-center" key={row.id}>
              <td >
                {editingId === row.id ? (
                  <Form.Control
                    value={row.whitelist_url}
                    onChange={(e) =>
                      handleChange('whitelist_url', e.target.value, row.id)
                    }
                  />
                ) : (
                  row.whitelist_url
                )}
              </td>
              <td >
                {editingId === row.id ? (
                  <Form.Control
                    value={row.tenant_url}
                    onChange={(e) =>
                      handleChange('tenant_url', e.target.value, row.id)
                    }
                  />
                ) : (
                  row.tenant_url
                )}
              </td>
              <td>
                {editingId === row.id ? (
                  <>
                  {moduleOptions.map((opt) => (
                    <Form.Check
                      key={opt.value}
                      type="checkbox"
                      label={opt.lable}
                      className="text-start"
                      checked={(row.module_section || []).includes(opt.value)}
                      onChange={(e) => {
                        const updated = e.target.checked
                          ? [...(row.module_section || []), opt.value]
                          : (row.module_section || []).filter((val) => val !== opt.value);
                        // const updated=['tickets']
                          console.log("module_section=",updated)
                        handleChange('module_section', updated, row.id);
                      }}
                    />
                  ))}
                  </>
                  ) : (
                   // (row.module_section || []).join(', ')
                   formatModuleNames(row.module_section)
                 )} 
              </td>
              <td>
                {editingId === row.id ? (
                  <Form.Select
                    value={row.vendor_ticketing_system}
                    onChange={(e) =>
                      handleChange('vendor_ticketing_system', e.target.value, row.id)
                    }
                  >
                    <option value="">Select</option>
                    {vendorOptions.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.lable}
                      </option>
                    ))}
                  </Form.Select>
                ) : (
                  row.vendor_ticketing_system =='jira'?"Jira":row.vendor_ticketing_system =='zoho'?'Zoho':row.vendor_ticketing_system =='ServiceNow'?row.vendor_ticketing_system:''
                )}
              </td>
              <td>
                {editingId === row.id ? (
                  <Form.Control
                    value={row.view_sdk_client}
                    onChange={(e) =>
                      handleChange('view_sdk_client', e.target.value, row.id)
                    }
                  />
                ) : (
                  row.view_sdk_client
                )}
              </td>
              <td>
                {editingId === row.id ? (
                  <>
                  <Check2Circle
                    color="green"
                    size={22}
                    style={{ cursor: 'pointer', marginRight: '10px' }}
                    onClick={() => handleSaveEdit(row.id)}
                  />
                  <XCircle
                  color="red"
                  size={22}
                  style={{ cursor: 'pointer' }}
                  onClick={() => setEditingId(null)}
                />
                </>
                ) : (
                  <PencilSquare
                    size={20}
                    style={{ cursor: 'pointer', marginRight: '10px' }}
                    onClick={() => handleEdit(row.id)}
                  />
                )}
                {/* <Trash
                  size={20}
                  style={{ cursor: 'pointer' }}
                  onClick={() => handleDelete(row.id)}
                /> */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination */}
      <div className="d-flex justify-content-end align-items-center mt-3 d-none">
        {/* <div>
          <Form.Select
            value={itemsPerPage}
            onChange={(e) => {
              setItemsPerPage(Number(e.target.value));
              setCurrentPage(1);
            }}
            style={{ width: '100px' }}
          >
            <option value={5}>5</option>
            <option value={10}>10</option>
            <option value={20}>20</option>
          </Form.Select>
        </div> */}

        <div>
          <ul className="pagination mb-0">
            {[...Array(totalPages)].map((_, index) => (
              <li
                key={index}
                className={`page-item ${
                  currentPage === index + 1 ? 'active' : ''
                }`}
              >
                <Button
                  className="page-link"
                  onClick={() => setCurrentPage(index + 1)}
                  size="sm"
                  variant="primary"
                >
                  {index + 1}
                </Button>
              </li>
            ))}
          </ul>
        </div>
      </div>
      </div>
    </div>
  );
};
  

export default TenantConfigTable;